import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { List, Separator, Spinner } from 'telia-front-react';

import { InvoiceFileType } from '../../../services/ApiService';
import InvoiceDetailsStore from '../../../stores/InvoiceDetailsStore';
import InvoiceFileStore from '../../../stores/InvoiceFileStore';
import WarningNotice from '../notices/WarningNotice';
import DownloadFileButton from './DownloadFileButton';

interface IInvoiceFileButtonsProps {
  invoiceDetailsStore?: InvoiceDetailsStore;
  invoiceFileStore?: InvoiceFileStore;
}

@inject('invoiceDetailsStore', 'invoiceFileStore')
@observer
export default class InvoiceFileButtons extends React.Component<IInvoiceFileButtonsProps> {
  public render(): JSX.Element {
    const invoiceFileStore = this.props.invoiceFileStore;

    if (invoiceFileStore.fileTypes.isFinishedWithError) {
      return <WarningNotice translationKey="shared.invoice-details-modal.failed-to-load-invoice-files" />;
    }

    if (invoiceFileStore.fileTypes.isFinished) {
      const invoiceDetailsRequest = this.props.invoiceDetailsStore.invoiceDetailsRequest;
      const invoiceFileTypes = invoiceFileStore.sortedInvoiceFileTypes;

      const listItems = [];
      invoiceFileTypes.forEach((invoiceFileType: InvoiceFileType) => {
        listItems.push(<DownloadFileButton invoiceDetailsRequest={invoiceDetailsRequest} invoiceFileType={invoiceFileType} key={invoiceFileType} />);
      });

      return (
        <>
          {invoiceFileStore.hasError(invoiceDetailsRequest.invoiceNumber) && (
            <>
              <WarningNotice translationKey="invoices.errors.file-loading-failed" />
              <Separator spacing="xsmall" color="invisible" />
            </>
          )}
          <List bordered={true} outerBordered={false} type="icon">
            {listItems}
          </List>
        </>
      );
    }

    return <Spinner />;
  }
}
